<otel-instrumentation></otel-instrumentation>
<app-global-banner></app-global-banner>
<global-header></global-header>
<main id="main-content">
  <router-outlet></router-outlet>
</main>
<global-footer></global-footer>